<script>
import { mapGetters } from 'vuex';
import { useAccount } from 'dashboard/composables/useAccount';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import NextButton from 'dashboard/components-next/button/Button.vue';

const WHATSAPP_RENEWAL_LINK = 'https://wa.me/5584936180448';

export default {
  components: { NextButton },
  setup() {
    const { accountId } = useAccount();

    return { accountId, whatsappRenewalLink: WHATSAPP_RENEWAL_LINK };
  },
  data() {
    return {
      isDismissed: LocalStorage.get(
        LOCAL_STORAGE_KEYS.DISMISSED_EXPIRATION_BANNER
      ),
    };
  },
  computed: {
    ...mapGetters({ getAccount: 'accounts/getAccount' }),
    account() {
      return this.getAccount(this.accountId) || {};
    },
    shouldShowBanner() {
      return !this.isDismissed && !!this.account.show_expiration_banner;
    },
    daysLeft() {
      return this.account.expiration_days_left;
    },
    expirationDate() {
      return this.account.expiration_date;
    },
    isOnTrial() {
      return this.account.display_status === 'trial';
    },
    renewalLinkLabel() {
      return this.isOnTrial
        ? this.$t('GENERAL_SETTINGS.ACCOUNT_EXPIRATION_BANNER.ACTIVATE_LINK')
        : this.$t('GENERAL_SETTINGS.ACCOUNT_EXPIRATION_BANNER.RENEW_LINK');
    },
  },
  methods: {
    onClose() {
      this.isDismissed = true;
      LocalStorage.set(LOCAL_STORAGE_KEYS.DISMISSED_EXPIRATION_BANNER, true);
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div
    v-if="shouldShowBanner"
    class="flex items-center justify-center h-12 gap-4 px-4 py-3 text-xs banner dark:text-white woot-banner bg-n-amber-5 text-n-amber-12 relative"
  >
    <span class="banner-message flex items-center gap-1">
      {{ $t('GENERAL_SETTINGS.ACCOUNT_EXPIRATION_BANNER.MESSAGE_PREFIX') }}
      <strong>{{ expirationDate }}</strong>
      -
      <strong>{{
        $t('GENERAL_SETTINGS.ACCOUNT_EXPIRATION_BANNER.DAYS_COUNT', {
          count: daysLeft,
        })
      }}</strong>
      <span
        >(<a
          :href="whatsappRenewalLink"
          rel="noopener noreferrer nofollow"
          target="_blank"
          class="underline text-n-amber-12 text-xs"
          >{{ renewalLinkLabel }}</a
        >)</span
      >
    </span>
    <NextButton
      icon="i-lucide-x"
      slate
      ghost
      xs
      class="absolute right-3"
      @click="onClose"
    />
  </div>
</template>
